import React from "react";
import "../sass/Content.scss";

const Privacy = () => {
  return (
    <div className="legalWrapper">
      <h1>Privacy Policy</h1>
      <p>Last updated on December 16, 2021</p>

      <p>
        YOU ARE ADVISED TO REVIEW THIS PRIVACY POLICY CAREFULLY TO UNDERSTAND
        OUR PRIVACY PRACTICES. BY USING OUR SERVICES (DEFINED BELOW), YOU AGREE
        TO THE COLLECTION AND USE OF INFORMATION IN ACCORDANCE WITH THIS POLICY
        AND ARE BOUND BY IT. UNLESS OTHERWISE DEFINED IN THIS PRIVACY POLICY,
        THE TERMS USED IN THIS PRIVACY POLICY SHALL HAVE THE SAME MEANINGS AS IN
        OUR TERMS AND CONDITIONS,
      </p>
      <p>
        ACCESSIBLE FROM www.skyserve.ai/legal YOU HEREBY CONSENT TO OUR
        COLLECTION, USE, STORING AND SHARING OF YOUR PERSONAL INFORMATION AS
        DESCRIBED UNDER THIS PRIVACY POLICY. IF YOU USE THE SERVICES ON BEHALF
        OF SOMEONE ELSE, YOU REPRESENT THAT YOU ARE AUTHORISED BY SUCH
        INDIVIDUAL OR ARE LEGALLY AUTHORIZED TO (I) ACCEPT THIS PRIVACY POLICY
        ON SUCH INDIVIDUAL'S BEHALF, AND (II) CONSENT ON BEHALF OF SUCH
        INDIVIDUAL TO OUR COLLECTION, USE AND DISCLOSURE OF SUCH INDIVIDUAL'S
        PERSONAL INFORMATION AS DESCRIBED IN THIS PRIVACY POLICY.
      </p>
      <p>
        WHILE USING OUR SERVICES YOU FURTHER UNDERSTAND THAT THIS WEBSITE MAY
        CONTAIN LINKS TO OTHER SITES THAT WE DO NOT OPERATE. IF YOU CLICK ON A
        THIRD-PARTY LINK, YOU WILL BE DIRECTED TO THAT THIRD PARTY'S SITE. WE
        ADVISE YOU TO REVIEW THE PRIVACY POLICY OF EVERY SITE YOU VISIT.
      </p>
      <p>
        WE HAVE NO CONTROL OVER AND ASSUME NO RESPONSIBILITY FOR THE CONTENT,
        PRIVACY POLICIES OR PRACTICES OF ANY THIRD-PARTY SITES OR SERVICES.
      </p>

      <ul>
        <li>
          <h3>INTRODUCTION</h3>
          <p>
            SkyServe Inc. ("SkyServe Inc", “us,” “we,” or “our”) is committed to
            provide You (“You”, “Your” and “User” and “Visitor” “Customer”) a
            secure and personalised experience of our services and for any other
            purposes by managing Your personal information as permitted or
            required by law. We respect the privacy of everyone who visits/uses
            the Website. The nature of services provided by us requires us to
            collect information including but not limited to Your name, age,
            gender, date of birth, Geolocation (defined below) and financial
            information (“Personal Information”). This privacy policy (“Privacy
            Policy”) describes the procedures for collecting, using, storing and
            managing Your Personal Information, which You share with us for
            availing the services / products or accessing the Website. We
            recommend You read this Privacy Policy so that You understand the
            type of Personal Information collected by us and the manner in which
            we process and manage Your Personal Information.
          </p>
          <p>
            We operate this website www.skyserve.ai (“Website”), to provide a
            platform (“Platform”) to avail our services and / or products
            (“Service”). Any person visiting this Website or using the Services
            shall be presumed to have read these Privacy Policy and
            unconditionally and irrevocably accepted the terms and conditions
            set out herein.
          </p>
        </li>
        <li>
          <h3>DEFINITION</h3>
          <ul>
            <li>
              “Archive” shall mean the process of moving and storing data that
              is no longer actively used to a separate storage device for
              long-term retention under this Privacy Policy;
            </li>
            <li>
              “Geolocation” shall mean the information used or intended to be
              used to determine the actual physical location of an individual or
              device with reasonable accuracy and specificity;
            </li>
            <li>
              “Purge” shall mean the process of permanently removing obsolete
              data from a specific storage location when it is no longer
              required under this Privacy Policy.
            </li>
          </ul>
        </li>

        <li>
          <h3>TYPE OF INFORMATION</h3>
          <p>
            We require to identify the User in order to provide our Services to
            the Users. Instances such as interaction with us via emails,
            telephone calls or other correspondence, requires identifying the
            User and we may ask You to voluntarily provide us with certain
            information that personally identifies You or could be used to
            personally identify You. We collect and store information provided
            by You to provide a better experience every time You visit our
            Website. Following are the categories of information collected by
            us:
          </p>

          <ul>
            <li>
              Contact Information: We store Your username, phone number, email
              address, password when You register for an account on our Website.
              We store Your contact information as provided by You while using
              our Website to reach out to discuss and address any concerns that
              You may have about our Services;
            </li>
            <li>
              Demographic data - We store Your information related to Your
              gender, Your date of birth and Your ZIP code;
            </li>
            <li>
              Cookies: Cookies are files with a small amount of data, including
              a unique anonymous identifier. Cookies are sent to Your browser
              from a website and stored on Your computer's hard drive. We use
              "Cookies" to collect information. We may use both Session Cookies
              (which expire once You close Your browser) and Persistent Cookies
              (which stay on Your computer until You delete them). You can
              instruct Your browser to refuse all cookies or to indicate when a
              cookie is being sent. However, if You do not accept cookies, You
              may not be able to use some portions of our Website or Services on
              this Website;
            </li>
            <li>
              Browsing information: We record information relating to Your use
              of our Services and Website, such as the searches You undertake,
              the pages You view, Your browser type, IP address, location,
              requested URL, referring URL, and timestamp information;
            </li>
            <li>
              Third-Party Services: We may use third-party services such as
              Google Analytics that collect, monitor, and analyze information to
              increase our Services’ functionality. These third- party service
              providers have their own privacy policies addressing how they use
              such information;
            </li>
            <li>
              Other Information: We also receive additional information about
              Your device and geolocation such as IP address.
            </li>
          </ul>
        </li>

        <li>
          <h3>HOW WE USE PERSONAL INFORMATION</h3>
          <p>
            The Personal Information is collected and used to the extent that is
            necessary for the purposes mentioned herein. The User’s personal
            information will be tracked/collected/processed/disseminated and
            stored for the purposes consented by the User, or which is
            incidental to or connected with such purpose and which the User
            would reasonably expect that such personal information shall be used
            for. Moreover, we will
          </p>

          <p>
            track/collect/process/disseminate and store the User’s personal
            information having regard to the purpose, and in the context and
            circumstances in which the personal data was collected. Specific
            purposes, for which we may track/collect/process/disseminate and
            store the User’s information include:
          </p>

          <ul>
            <li>
              To provide You with the Services offers, or information as offered
              by Us;
            </li>
            <li>To identify the User whenever necessary;</li>
            <li>
              To understand how You and others use our Services for analytics
              and modeling and to create business intelligence and insights, and
              to understand economic trends;
            </li>
            <li>
              To support our everyday business purposes, such as account
              management, quality control, website administration, business
              continuity and disaster recovery, security and fraud prevention,
              corporate governance, reporting, and legal compliance. Please note
              that we may also use and disclose information that is not
              personally identifiable.
            </li>
            <li>
              To aggregate information to perform statistical analyses of User
              behavior and characteristics to measure interest in our Services;
            </li>
            <li>
              To carry out our legal compliance obligations according to the
              applicable laws being in force at the time;
            </li>
            <li>
              To share with any third-party certain information, that we have
              collected to better understand which services and advertisements
              may interest You.
            </li>
          </ul>
        </li>

        <li>
          <h3>DISLCOSURES</h3>

          <ul>
            <li>
              Affiliates. We may provide Personal Information to our affiliates.
              For example, we may disclose Personal Information collected under
              this Policy to our affiliates in order to respond to Your requests
              for information or Services or to help limit Your receipt of
              marketing materials You have requested not to receive;
            </li>
            <li>
              Service Providers or Business Partners. We may use certain
              third-party companies and individuals to help provide, analyze,
              and improve the Services (including but not limited to data
              storage, maintenance services, database management, web analytics,
              payment processing, hosting services, business functions and
              improvement of the Service's features.) The third parties may have
              access to Your information only for purposes of performing these
              tasks on our behalf and shall be incompliance with the terms of
              this Privacy Policy;
            </li>
            <li>
              Third-Party Applications: We may share Your information to third
              parties with Your consent, when You choose to access our Services
              through such an application. We have no control over how the
              information is processed by the third-party application. We shall
              not be responsible for any breach on account of such parties and
              You consent to the use of your information;
            </li>
            <li>
              Joint Marketing Arrangements. Where permitted by law, we may
              provide Personal Information to joint marketers with whom we have
              a marketing arrangement, if any. We shall require all joint
              marketers to have written contracts with us that specify
              appropriate use of Your Personal Information, require them to
              safeguard Your Personal Information, and prohibit them from making
              unauthorized or unlawful use of Your Personal Information;
            </li>
            <li>
              Analysis: Information given by You may be used for making
              presentations, consolidation reports, analysis etc. However, in
              all such cases, Your identity will be protected and no personal
              information shall be parted to any third party. Your contact
              information is stored in our database and is only used to contact
              You during the course of Your association with us;
            </li>
            <li>
              Persons Who Acquire Our Assets or Business. If we sell or transfer
              any of our business or assets, certain Personal Information may be
              a part of that sale or transfer. Legal and Regulatory Authorities.
              We may be required to disclose Your Personal Information due to
              legal or regulatory requirements. In such instances, we reserve
              the right to disclose Your Personal Information as required in
              order to comply with our legal obligations, including but not
              limited to complying with court orders, warrants, or discovery
              requests. You agree and acknowledge that we may not inform You
              prior to or after disclosures made according to this section.
            </li>
          </ul>
        </li>

        <li>
          <h3>DATA RETENTION</h3>
          <p>
            We may retain, Purge and Archive Your data and will use Your
            Personal Information as necessary to comply with our legal
            obligations, resolve disputes, and enforce our agreements.
            Consistent with these requirements, we shall try to delete Your
            Personal Information quickly upon reasonable request and the
            information which is no longer required. Please note, however, that
            there might be latency in deleting Personal Information from our
            servers and backed-up versions might exist after deletion. In
            addition, we do not delete from our servers’ files that You have in
            common with other Users.
          </p>
        </li>

        <li>
          <h3>TRANSFER OF DATA</h3>
          <p>
            Your information, including Personal Data, may be transferred to and
            maintained on computers located outside of Your state, province,
            country or other governmental jurisdiction with appropriate security
            measures and standards.
          </p>
          <p>
            Your consent to this Privacy Policy followed by Your submission of
            such information represents Your agreement to that transfer.
          </p>
          <p>
            We will take all the steps reasonably necessary to ensure that Your
            data is treated securely and in accordance with this Privacy Policy
            and no transfer of Your Personal Data will take place to an
            organisation or a country unless there are adequate controls in
            place including the security of Your data and other personal
            information.
          </p>
        </li>

        <li>
          <h3>INDEMNIFICATION</h3>
          <ul>
            <li>
              The User agrees and undertakes to indemnify and hold harmless
              SkyServe Inc from and against any and all suit, dispute, actions,
              damages, costs and expenses, if any, of whatsoever nature, arising
              out of or in any way connected with this Privacy Policy,
              information and/or the User’s use or access to this Website;
            </li>
            <li>
              The User expressly understands that under no circumstances,
              including, but not limited to, negligence, shall We be liable to
              the User for any direct, indirect, incidental, special, or
              consequential damages, including, but not limited to damages for
              loss of profits, goodwill, use, data or other intangible losses,
              resulting from circumstances, including but not limited to:
              <ul>
                <li>
                  unauthorized access to or alteration of Personal Information;
                </li>
                <li>
                  any unauthorized access to or use of our secure servers and/or
                  any or all information stored therein;
                </li>
                <li>
                  The User represents that the User has accessed the Website and
                  has provided information on the User’s own initiative and is
                  responsible for compliance with all applicable laws including,
                  but not limited to, any applicable local laws.
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          <h3>LIMITATION OF LIABILITY</h3>
          <p>
            SkyServe Inc shall not be liable for any damages, direct or
            indirect, incidental or consequential, and all liabilities
            (including for negligence, loss or damage such as loss of products,
            unavailability of system or loss of data and loss of Your Personal
            Information) and for use of or inability to use Services of any kind
            that is offered or to provide indemnity or any other remedy to You
            or any third party.
          </p>
        </li>

        <li>
          <h3>ACCESS</h3>
          <p>
            You can access Your information, including Your name, address,
            payment options, profile information and other details in the
            'Account' section of the website.
          </p>
          <p>
            You shall not share Your Personal Information (for example, Your
            name, mobile number and email address) unless You are an individual
            of at least eighteen (18) years of age who can enter into legally
            binding contracts under applicable law or a corporation, trust,
            association of persons or firm which can enter into legally binding
            contracts under applicable law. In case of a corporation, trust,
            association of persons or a firm, You must be authorised to agree to
            this Privacy Policy.
          </p>
        </li>

        <li>
          <h3>CHANGES TO THIS PRIVACY POLICY</h3>
          <p>
            This Privacy Policy may be revised or altered by us at our sole
            discretion at any time without any prior intimation to You. The
            latest Privacy Policy will be posted here along with the date of
            change. Any such changes by Us will be effective immediately. By
            continuing to use this Website or to access the Services / usage of
            our Services after changes are made, You agree to be bound by the
            revised/ amended terms of this Privacy Policy and such amendments
            shall supersede all other terms of Privacy Policy previously
            accepted by You. Therefore, the User is requested to check the
            Privacy Policy regularly for updates.
          </p>
        </li>

        <li>
          <h3>GOVERNING LAW</h3>
          <p>
            This Privacy Policy is governed by the laws of United States of
            America for Users all over the world and the appropriate courts at
            Delaware U.S.A shall have exclusive jurisdiction.
          </p>
        </li>

        <li>
          <h3>FEEDBACK</h3>

          <ul>
            <li>
              We are interested in Your views, and we value feedback, we
              therefore may set up blogs and chat rooms for providing better
              Services and to receive Your feedbacks. We encourage You to be
              careful about what Personal Information You disclose in this way;
            </li>
            <li>
              Subject to any applicable law, any communication sent by You via
              SkyServe Inc or through the blogs chat rooms or otherwise to us
              (including without limitation contents, images, audio, feedback
              etc. collectively "Feedback") is on a non-confidential basis, and
              we are under no obligation to refrain from reproducing, publishing
              or otherwise using it in any way or for any purpose. We can use
              the Feedback, including without limitation to any ideas,
              inventions, concepts, techniques or know-how disclosed therein,
              for any purpose including without limitation to developing,
              manufacturing and/or marketing Services. You agree You shall not
              assert any ownership right of any kind in the Feedback (including
              without limitation copyright, patent, Trademark, unfair
              competition, moral rights, or implied contract) and You hereby
              irrevocably waive the right to receive any financial or other
              consideration in connection with the Feedback, including without
              limitation acknowledgment of You as the source of the Feedback.
              Your submission of any Feedback shall constitute an assignment to
              us of all worldwide rights, titles and interests in all copyrights
              and other intellectual property rights in the Feedback;
            </li>
            <li>
              If You register or respond to advertisements or post any content
              on Website, we may send You certain notifications, advertisements,
              promotions, surveys and specials. We may also send You any legally
              required notifications and certain notifications, including but
              not limited to, Service- related notices or notices regarding a
              change to any of our policies. For example, we may send You a
              notice regarding server problems or scheduled maintenance to
              SkyServe Inc. In order to opt-out of receiving these notices, You
              may need to deactivate Your account. We shall not change Your
              preferences without Your consent.
            </li>
          </ul>
        </li>

        <li>
          <h3>CONTACT US</h3>
          <p>
            If You have questions or concerns or grievances regarding this
            Privacy Policy, You can e-mail us at{" "}
            <a href="mailto: hello@skyserve.ai">hello@skyserve.ai</a>.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default Privacy;
